import { render, staticRenderFns } from "./PreferencesPersonal.vue?vue&type=template&id=2a966157&scoped=true&"
import script from "./PreferencesPersonal.vue?vue&type=script&lang=js&"
export * from "./PreferencesPersonal.vue?vue&type=script&lang=js&"
import style0 from "./PreferencesPersonal.vue?vue&type=style&index=0&id=2a966157&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a966157",
  null
  
)

export default component.exports